import React from 'react'
import StyledSplitScreen from './SplitScreen.styles'

/**
 * Splits the child components into a split screen.
 * Only the first two children will render.
 */
export default function SplitScreen({ children }) {
    const [left, right] = children
    return (
        <StyledSplitScreen>
            <div className="left">{left}</div>
            <div className="right">{right}</div>
        </StyledSplitScreen>
    )
}
